import { render, staticRenderFns } from "./ToggleForm.vue?vue&type=template&id=5fe4fdfa&scoped=true&"
import script from "./ToggleForm.vue?vue&type=script&lang=js&"
export * from "./ToggleForm.vue?vue&type=script&lang=js&"
import style1 from "./ToggleForm.vue?vue&type=style&index=1&id=5fe4fdfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe4fdfa",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VImg,VProgressCircular,VSpacer,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fe4fdfa')) {
      api.createRecord('5fe4fdfa', component.options)
    } else {
      api.reload('5fe4fdfa', component.options)
    }
    module.hot.accept("./ToggleForm.vue?vue&type=template&id=5fe4fdfa&scoped=true&", function () {
      api.rerender('5fe4fdfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/ToggleForm.vue"
export default component.exports